module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007_Preface#fm-1"
    }
  }, [_vm._v("Preface to Volume 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Intro#fm-2"
    }
  }, [_vm._v("Introduction: Federal Religious Liberty Legislation after RFRA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01#ch-1"
    }
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NE:")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTY")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROTECTION")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01#sec2-1"
    }
  }, [_vm._v("1997 House Testimony on Responding to "), _c('em', [_vm._v("Boerne")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01#sec2-1a"
    }
  }, [_c('em', [_vm._v("Protecting Religious Freedom after Boerne v. Flores: Hearing before the Subcommittee on the Constitution of the House Committee on the Judiciary 46 (July 14, 1997)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01#sec2-2"
    }
  }, [_vm._v("1997 Senate Testimony on Responding to "), _c('em', [_vm._v("Boerne")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01#sec2-2a"
    }
  }, [_c('em', [_vm._v("Congress’s Constitutional Role in Protecting Religious Liberty: Hearing before the Senate Committee on the Judiciary 4 (Oct. 1, 1997)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01#sec2-3"
    }
  }, [_vm._v("Letter to Charles T. Canady re Eisgruber-Sager Objections "), _c('em', [_vm._v("(June 8, 1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01#sec2-4"
    }
  }, [_vm._v("June 1998 House Testimony on Religious Liberty Protection Act")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01#sec2-4a"
    }
  }, [_c('em', [_vm._v("Religious Liberty Protection Act of 1998: Hearing before the Subcommittee on the Constitution of the House Committee on the Judiciary, 105th Cong. 8 (June 16, 1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01a#sec2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Robert C. Scott re Democratic Objections "), _c('em', [_vm._v("(June 22, 1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/009_Part01a#sec2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1998 Senate Testimony on Religious Liberty Protection Act")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01a#sec2-6a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Religious Liberty Protection Act of 1998: Hearing before the Senate Committee on the Judiciary on S. 2148, 105th Cong. 49 (June 23, 1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("July 1998 House Testimony on Religious Liberty Protection Act")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-7a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Religious Liberty Protection Act of 1998: Hearing before the Subcommittee on the Constitution of the House Committee on the Judiciary on H.R. 4019, 105th Cong. 222 (July 14, 1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RLPA Opponents Grossly Distort Laycock Testimony on Gay Rights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-8a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Justice Fellowship (July 23, 1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mike Farris’s False Charges about the Religious Liberty Protection Act")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-9a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Coalition for the Free Exercise of Religion (July 24, 1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Do We Lose by Taking Out the Commerce Clause Section? Preliminary Listing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-10a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Coalition for the Free Exercise of Religion (Aug. 6, 1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1999 House Testimony on Religious Liberty Protection Act")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-11a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Religious Liberty Protection Act of 1999: Hearing before the Subcommittee on the Constitution of the House Committee on the Judiciary on H.R. 1691, 106th Cong. 100 (May 12, 1999)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Charles T. Canady re Texas Civil Rights Exception "), _c('em', [_vm._v("(June 14, 1999)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memorandum to Cathy Cleaver re New Federalism Cases "), _c('em', [_vm._v("(June 26, 1999)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talking Points in Response to the Dissenting Views of Representatives Conyers "), _c('em', [_vm._v("et al.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-14a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Coalition for the Free Exercise of Religion (July 9, 1999)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RLPA Fully Consistent with Federalism and Dual Sovereignty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-15a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Coalition for the Free Exercise of Religion (July 13, 1999)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1999 Senate Testimony on Religious Liberty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-16a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Religious Liberty: Hearing before the Senate Committee on the Judiciary on Issues Relating to Religious Liberty Protection, and Focusing on the Constitutionality of a Religious Protection Measure (Sept. 9, 1999)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Part02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WO")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SE AND")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NSTITUTIONALIZED")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERSONS")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter01#sec-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("A."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Land Use Provisions")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter01#sec2-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to David Abney re Cases Pending at Enactment "), _c('em', [_vm._v("(February 28, 2001)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter01#sec2-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zoning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter01#sec2-18a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in Encyclopedia of Religious Freedom 519 (Catharine Cookson ed., Routledge 2003)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter01#sec2-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RLUIPA: Necessary, Modest, and Under-Enforced")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter01#sec2-19a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("39 Fordham Urban Law Journal 1021 (2012)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("B."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Prison Provisions")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec2-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holt v. Hobbs, "), _c('em', [_vm._v("135 S. Ct. 853 (2015)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Petitioner’s Supplemental Brief (at Petition Stage)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Petitioner’s Reply Brief (at Petition Stage)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brief for the Petitioner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reply Brief for the Petitioner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rule 32.3 Lodging of Documents Not in the Record")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oral Argument")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HREE")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTY AND")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HARITABLE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONATION")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROTECTION")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("A."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Litigation")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christians v. Crystal Evangelical Free Church (In re Young)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-21a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("82 F.3d 1407 (8th Cir. 1996)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec3-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Post-Argument Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec3-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brief in Opposition to [First] Petition for Writ of Certiorari")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christians v. Crystal Evangelical Free Church (In re Young)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-22a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("141 F.3d 854 (8th Cir. 1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec3-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brief of Appellant on Remand from the Supreme Court of the United States")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reply Brief of Appellant on Remand from the Supreme Court of the United States")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brief in Opposition to [Second] Petition for Writ of Certiorari")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cedar Bayou Baptist Church of Baytown v. Gregory-Edwards, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-23a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("987 S.W.2d 156 (Tex. App. 1999)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brief of Appellant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reply Brief of Appellant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Supplemental Brief of Appellant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Post-Argument Brief of Appellant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("B."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Legislation")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec2-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Senate Testimony")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec2-24a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bankruptcy Issues in Review: The Bankruptcy Code’s Effect on Religious Freedom and a Review of the Need for Additional Bankruptcy Judgeships: Hearing Before the Subcommittee on Administrative Oversight and the Courts of the Senate Committee on the Judiciary 23 (Sept. 22, 1997)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec2-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Chris Peace and John McMickle re Preemption "), _c('em', [_vm._v("(November 20, 1997)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec2-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("House Testimony")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec2-26a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Religious Liberty and Charitable Donation Protection Act of 1997; and Religious Fairness in Bankruptcy Act of 1997: Hearing before the Subcommittee on Commercial and Administrative Law of the House Committee on the Judiciary 28 (Feb. 12, 1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec2-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Senator Charles Grassley re Tax "), _c('em', [_vm._v("(May 6, 1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/016_Part04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUR")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTINUING")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLICY")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EBATE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter05#sec-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("A."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The General Debate over Exemptions")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter05#sec2-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Syllabus of Errors: Reviewing Marci A. Hamilton, God vs. the Gavel: Religion and the Rule of Law (2005)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter05#sec2-28a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("105 Michigan Law Review 1169 (2007)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter05#sec2-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God vs. the Gavel: A Brief Rejoinder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter05#sec2-29a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("105 Michigan Law Review 1545 (2007)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter05#sec2-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Religious Exemption Debate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter05#sec2-30a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("11 Rutgers Journal of Law and Religion 139 (2009)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#sec-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("B."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Exemptions in the Culture-Wars Cases: Abortion, Contraception, and Same-Sex Marriage")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#sec2-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sex, Atheism, and the Free Exercise of Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#sec2-31a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("88 University of Detroit Mercy Law Review 407 (2011)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#sec2-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to the Editor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#sec2-32a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("First Things (May 2012)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#sec2-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bishops and Religious Liberty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#sec2-33a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Commonweal 27 (June 15, 2012)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#sec2-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Is the Future of Religious Freedom in the United States?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#sec2-34a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Moment (March–April 2013)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#sec2-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Liberty and the Culture Wars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06#sec2-35a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2014 University of Illinois Law Review")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06a#sec2-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Campaign against Religious Liberty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06a#sec2-36a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in The Rise of Corporate Religious Liberty 231 (Micah Schwartzman, Chad Flanders, and Zoe Robinson eds., Oxford 2016)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06a#sec2-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Liberty for Politically Active Minority Groups: A Response to NeJaime and Siegel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06a#sec2-37a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("125 Yale Law Journal Forum 369 (2016)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/018_Chapter06a#sec2-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contemporary Resistance to the Free Exercise of Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06a#sec2-38a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Sightings, https://divinity.uchicago.edu/sightings/contemporary-hostility-free-exercise-religion (March 3, 2016)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06a#sec2-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Liberty, Health Care, and the Culture Wars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06a#sec2-39a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in Law, Religion, and Health in the United States 21 (Holly Fernandez Lynch et al. eds., Cambridge 2017)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06a#sec2-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protecting Religious Liberty in the Culture Wars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter06a#sec2-40a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in Deep Commitments: The Past, Present, and Future of Religious Liberty (Trevor Burrus & David McDonald eds., Cato Institute 2017)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Part05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IVE")]), _vm._v(": O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THER")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTY")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EGISLATION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Part05#sec2-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in Ansonia Board of Education v. Philbrook")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Part05#sec2-41a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("479 U.S. 60 (1986)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Part05#sec2-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Barack Obama re Muslim Veils "), _c('em', [_vm._v("(July 10, 2009)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0999ad29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 72
// module chunks = 0